import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { OrderedSet } from 'immutable'
import { connect } from 'react-redux'
import { compose, pure } from 'recompose'
import classNames from 'classnames'

import { selectors as UsersSelectors } from 'data/users'
import { selectors as NotesSelectors } from 'data/notes'
import { UserAvatar } from 'components/Utils/Avatar'
import MetaUsersList from './List'

const LIMIT_USERS_DISPLAYED = 3

class MetaUsers extends Component {
  static propTypes = {
    noteId: PropTypes.string.isRequired,
    channelId: PropTypes.string.isRequired,
    userIds: PropTypes.object,
    size: PropTypes.string,
    direction: PropTypes.string,
    className: PropTypes.any,
  }

  render() {
    const { userIds, className, noteId, channelId } = this.props
    if (!userIds || userIds.size === 0) {
      return false
    }
    const numUsers = userIds.size
    return (
      <div
        className={classNames(
          'flexbox flexbox-column flexbox-align-center padding-vertical-small padding-horizontal-normal',
          className
        )}
      >
        {userIds
          .toArray()
          .slice(0, LIMIT_USERS_DISPLAYED)
          .map(userId => (
            <div
              key={userId}
              className="margin-bottom-small"
              style={{
                width: 24,
                height: 24,
              }}
            >
              <UserAvatar
                userId={userId}
                size="small"
                borderClass="border-small border-shade-100"
                backgroundClass="background-shade-50"
                colorClass="shade-20"
              />
            </div>
          ))}
        {numUsers > LIMIT_USERS_DISPLAYED && (
          <MetaUsersList
            channelId={channelId}
            userIds={userIds}
            noteId={noteId}
            numUsers={numUsers}
            limit={LIMIT_USERS_DISPLAYED}
          />
        )}
      </div>
    )
  }
}

const defaultUserIds = OrderedSet()

const mapStateToProps = (state, { noteId }) => {
  const note = NotesSelectors.getNote(state, noteId)
  return {
    channelId: note && note.channelId,
    userIds:
      UsersSelectors.getUserIdsPresenceByNoteId(state).get(noteId) ||
      defaultUserIds,
  }
}

export default compose(
  pure,
  connect(mapStateToProps)
)(MetaUsers)
